<agr-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (cancel)="cancel()"
  [data]="data"
  class="slide-in"
>
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="barn"
        data-test="medication-edit-item__barn"
      >
        <mat-option *ngFor="let barnMapping of data.barnMappings" [value]="barnMapping">
          {{ barnMapping.barnName }} - {{ barnMapping.animalGroupBarnId }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.treatmentDateStart' | translate }}</mat-label>
      <input
        matInput
        formControlName="startDate"
        [matDatepicker]="medicationDatePicker"
        placeholder="{{ 'animal-group.treatmentDateStart' | translate }}"
        data-test="medication-edit-item__date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="medicationDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #medicationDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.treatmentDateEnd' | translate }}</mat-label>
      <input
        matInput
        formControlName="endDate"
        [matDatepicker]="medicationDateEndPicker"
        placeholder="{{ 'animal-group.treatmentDateEnd' | translate }}"
        data-test="medication-edit-item__dateend"
      />
      <mat-datepicker-toggle matIconSuffix [for]="medicationDateEndPicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #medicationDateEndPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'product-overview.country' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="country"
        data-test="medication-edit-item__country"
        [(ngModel)]="selectedCountry"
        (ngModelChange)="countryChanged($event)"
      >
        <mat-option *ngFor="let country of data.countries" [value]="country">
          {{ country }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.medication' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="medicine"
        data-test="medication-edit-item__medicine"
      >
        <mat-option *ngFor="let medicine of codelistMedicinesByCountry" [value]="medicine">
          {{ medicine.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.quantity' | translate }}</mat-label>
      <input
        matInput
        type="number"
        step="any"
        formControlName="quantity"
        data-test="medication-edit-item__quantity"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.unit' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="unit"
        data-test="medication-edit-item__unit"
      >
        <mat-option
          *ngFor="let unit of data.codelistQuantityUnits"
          [value]="unit"
          [matTooltip]="'animal-group.quantityUnitDescriptions.' + unit.descriptionCode | translate"
        >
          {{ unit.unit }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.diagnose' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="diagnosis"
        data-test="medication-edit-item__diagnosis"
      >
        <mat-option *ngFor="let diagnosis of data.codelistDiagnoses" [value]="diagnosis">
          {{ diagnosis.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-dialog>
